import { render, staticRenderFns } from "./Anio2020.vue?vue&type=template&id=795ce3f8&scoped=true"
import script from "./Anio2020.vue?vue&type=script&lang=js"
export * from "./Anio2020.vue?vue&type=script&lang=js"
import style0 from "./Anio2020.vue?vue&type=style&index=0&id=795ce3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ce3f8",
  null
  
)

export default component.exports